import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import clsx from 'clsx';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

const StepThree = ({ handleChange, data, isValid }) => {
    const [activeTab, setActiveTab] = useState(data.activeTab || 'liana');
    const [tests, setTests] = useState(data.tests || []);
    const [selectedTests, setSelectedTests] = useState(data.selectedTests || []);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const [jobsData, setJobsData] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [categories, setCategories] = useState([]);

    const toast = useRef(null);

    useEffect(() => {
        if (activeTab === 'tests') fetchTests(currentPage);
        if (activeTab === 'jobs') fetchJobsData();
    }, [currentPage, activeTab]);

    const fetchTests = async (page) => {
        setLoading(true);
        if (tests.length > 0) {
            setLoading(false);
            return;
        }

        try {
            const response = await axios.get(`/api/v1/tests?page=${page}`, {
                headers: {
                    'X-App-Locale': window.locale || 'fr'
                }
            });

            setTests(response.data.data.items);
            console.log('response.data.data.items', response.data.data.items);
            setTotalPages(response.data.data.pages);
        } catch (error) {
            console.error('Failed to fetch tests:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchJobsData = () => {
        const jobData = ([
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Comptable', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Responsable RH', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Recruteur', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Contrôleur de gestion', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Analyste stratégique', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Chef de projet', Cyrious: true, ExVert: true, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Secrétaire administratif', Cyrious: true, ExVert: false, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Gestionnaire de bureau', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Responsable conformité', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: true, DTer: false },
            { Catégorie: 'Administration, Gestion, et Affaires Publiques', Métiers: 'Consultant en management', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Banques et Assurances', Métiers: 'Caissier de banque', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: true, DTer: false },
            { Catégorie: 'Banques et Assurances', Métiers: 'Analyste financier', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: true, DTer: false },
            { Catégorie: 'Banques et Assurances', Métiers: 'Agent d\'assurance', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Banques et Assurances', Métiers: 'Conseiller en investissement', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Banques et Assurances', Métiers: 'Actuaire', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Banques et Assurances', Métiers: 'Gestionnaire des risques', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Banques et Assurances', Métiers: 'Gestionnaire de portefeuille', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Banques et Assurances', Métiers: 'Audit et contrôle comptables/financiers', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Commerce et Immobilier', Métiers: 'Agent immobilier', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Commerce et Immobilier', Métiers: 'Vendeur en magasin', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Commerce et Immobilier', Métiers: 'Ingénieur commercial ', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Commerce et Immobilier', Métiers: 'Responsable commercial', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Commerce et Immobilier', Métiers: 'Chargé de clientèle', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Commerce et Immobilier', Métiers: 'Spécialiste des relations clients', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Commerce et Immobilier', Métiers: 'Responsable de boutique', Cyrious: true, ExVert: false, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Commerce et Immobilier', Métiers: 'Responsable des achats', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Enseignement et Formation', Métiers: 'Professeur d\'école primaire', Cyrious: false, ExVert: true, HopN: true, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Enseignement et Formation', Métiers: 'Professeur d\'université', Cyrious: false, ExVert: false, HopN: true, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Enseignement et Formation', Métiers: 'Formateur en entreprise', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Enseignement et Formation', Métiers: 'Conseiller en orientation', Cyrious: true, ExVert: false, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Enseignement et Formation', Métiers: 'Conseiller pédagogique', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Hôtellerie, Restauration et Alimentation', Métiers: 'Directeur d\'hôtel', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Hôtellerie, Restauration et Alimentation', Métiers: 'Serveur', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Hôtellerie, Restauration et Alimentation', Métiers: 'Responsable  service en salle', Cyrious: false, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Hôtellerie, Restauration et Alimentation', Métiers: 'Employé polyvalent', Cyrious: false, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Hôtellerie, Restauration et Alimentation', Métiers: 'Chef de rang', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: true },
            { Catégorie: 'Hôtellerie, Restauration et Alimentation', Métiers: 'Manager en restauration rapide', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Hôtellerie, Restauration et Alimentation', Métiers: 'Responsable de restauration', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Industrie', Métiers: 'Superviseur de production', Cyrious: true, ExVert: false, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Industrie', Métiers: 'Opérateur de machine', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: true, DTer: false },
            { Catégorie: 'Informatique et Télécommunications', Métiers: 'Développeur web', Cyrious: true, ExVert: false, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Informatique et Télécommunications', Métiers: 'Analyste en cybersécurité', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: true, DTer: false },
            { Catégorie: 'Informatique et Télécommunications', Métiers: 'Chef de projet IT', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Informatique et Télécommunications', Métiers: 'Administrateur réseau', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Informatique et Télécommunications', Métiers: 'Ingénieur logiciel', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Informatique et Télécommunications', Métiers: 'Data Analyst', Cyrious: true, ExVert: false, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Informatique et Télécommunications', Métiers: 'Consultant en transformation digitale', Cyrious: true, ExVert: true, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Marketing et Vente', Métiers: 'Responsable marketing', Cyrious: true, ExVert: true, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Marketing et Vente', Métiers: 'Chef de produit', Cyrious: true, ExVert: true, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Marketing et Vente', Métiers: 'Responsable des ventes', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Marketing et Vente', Métiers: 'Community Manager', Cyrious: false, ExVert: true, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Marketing et Vente', Métiers: 'Chargé de communication', Cyrious: false, ExVert: true, HopN: true, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Marketing et Vente', Métiers: 'Assistant Marketing', Cyrious: false, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Marketing et Vente', Métiers: 'Spécialiste en SEO', Cyrious: true, ExVert: false, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Marketing et Vente', Métiers: 'Gestionnaire de contenu', Cyrious: true, ExVert: false, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Recherche et Sciences', Métiers: 'Chercheur', Cyrious: true, ExVert: false, HopN: true, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Recherche et Sciences', Métiers: 'Statisticien', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Recherche et Sciences', Métiers: 'Biostatisticien', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Recherche et Sciences', Métiers: 'Ingénieur de laboratoire', Cyrious: true, ExVert: false, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Recherche et Sciences', Métiers: 'Scientifique en R&D', Cyrious: true, ExVert: true, HopN: true, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Santé', Métiers: 'Infirmier', Cyrious: true, ExVert: true, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Santé', Métiers: 'Orthophoniste', Cyrious: true, ExVert: false, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Santé', Métiers: 'Nutritionniste', Cyrious: true, ExVert: false, HopN: false, Sympact: true, Harmonia: false, DTer: false },
            { Catégorie: 'Santé', Métiers: 'Médecin superviseur', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Santé', Métiers: 'Psychologue', Cyrious: true, ExVert: false, HopN: false, Sympact: true, Harmonia: true, DTer: false },
            { Catégorie: 'Sécteur Publique, Juridique et Sécurité', Métiers: 'Policier', Cyrious: true, ExVert: true, HopN: false, Sympact: false, Harmonia: false, DTer: false },
            { Catégorie: 'Sécteur Publique, Juridique et Sécurité', Métiers: 'Juge administratif', Cyrious: true, ExVert: false, HopN: false, Sympact: false, Harmonia: false, DTer: true },
            { Catégorie: 'Sécteur Publique, Juridique et Sécurité', Métiers: 'Avocat', Cyrious: true, ExVert: false, HopN: false, Sympact: true, Harmonia: true, DTer: false },
            { Catégorie: 'Sécteur Publique, Juridique et Sécurité', Métiers: 'Fonctionnaire', Cyrious: true, ExVert: false, HopN: false, Sympact: true, Harmonia: false, DTer: false }
        ]);

        setJobsData(jobData);

        const uniqueCategories = Array.from(new Set(jobData.map(job => job.Catégorie).filter(cat => cat !== '')));
        const categoryOptions = uniqueCategories.map(cat => ({ label: cat, value: cat }));
        setCategories(categoryOptions);
    };

    const handleTestClick = (test) => {
        const isTestSelected = selectedTests.some(selectedTest => selectedTest.ref === test.ref);
        if (isTestSelected) {
            const updatedTests = selectedTests.filter(t => t.ref !== test.ref);
            setSelectedTests(updatedTests);
            if (updatedTests.length === 0) setSelectedCategory('');
        } else {
            if (selectedTests.length === 0 || selectedTests[0].category === test.category) {
                setSelectedTests([...selectedTests, test]);
                setSelectedCategory(test.category);
            } else {
                toast.current.show({
                    severity: 'warn',
                    summary: 'Selection Error',
                    detail: 'You cannot select tests from both categories simultaneously.',
                    life: 3000,
                    position: 'bottom-right',
                });
            }
        }
    };

    const handleTagRemove = (test) => {
        const updatedTests = selectedTests.filter(t => t !== test);
        setSelectedTests(updatedTests);
        if (updatedTests.length === 0) setSelectedCategory('');
    };

    const handlePageClick = (page) => {
        if (page !== currentPage) setCurrentPage(page);
    };

    useEffect(() => {
        handleChange({ activeTab, tests, selectedTests });
        if (selectedTests?.length > 0) isValid({ step: '2' });
        else isValid(false);
    }, [activeTab, tests, selectedTests]);

    const lianaRender = () => (
        <div className="container" style={{ position: 'relative' }}>
            <h1 className="liana-text big mt-5">
                L<span className="liana-i">i</span><span className="liana-a">A</span>na.
            </h1>
            <div className="field has-addons has-addons-centered pr-2 pl-2">
                <div className="control is-expanded">
                    <input className="input is-large radius-20" type="text" />
                </div>
                <div className="control">
                    <button className="button is-large is-info radius-20 ml-4">Go</button>
                </div>
            </div>
            <div className="columns is-centered">
                <div className="column has-text-centered"><p>Sales Manager</p></div>
                <div className="column has-text-centered"><p>Responsable RH</p></div>
                <div className="column has-text-centered"><p>Développeur Web</p></div>
            </div>
            <p className="subtitle is-5 has-text-centered is-max-width-10 m-0-auto pb-5">
                LiAna vous trouve les soft skills en fonction du métier pour lequel vous recrutez.
            </p>
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(55, 55, 55, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '1.5em',
                    fontWeight: 'bold',
                    borderRadius: '15px',
                    borderWidth: 4,
                    borderStyle: 'dashed',
                    zIndex: 1000,
                }}
            >
                <span style={{ transform: 'rotate(25deg)', fontSize: 22, color: '#919191' }}>
                    Cette fonctionnalité arrive bientôt !
                </span>
            </div>
        </div>
    );

    const testsRender = () => (
        <>
            <Toast ref={toast} />
            <section id="tests_list" className="container section">
                <div id="selected_tests" className={clsx('tags', { 'is-active': selectedTests.length > 0 })}>
                    <span className="subtitle is-6 mr-2 mb-0">Tests sélectionnés : </span>
                    {selectedTests.length > 0 && (
                        <>
                            {selectedTests.map(test => (
                                <Tag
                                    key={`test-tag-${test.ref}`}
                                    className="selected_test__tag mt-1"
                                    style={{
                                        background: `linear-gradient(90deg, ${test.test_color !== '#FFFFFF' ? test.test_color : '#4786C6'}, ${test.test_color !== '#FFFFFF' ? test.test_color + '63' : '#4786C6' + '63'})`,
                                    }}
                                    onClick={() => handleTagRemove(test)}
                                >
                                    <span className="mr-2">{test.title}</span>
                                    <i className="fa-regular fa-circle-xmark"></i>
                                </Tag>
                            ))}
                        </>
                    )}
                </div>

                <div className="category-section">
                    <h2 className="category-title">Recrutement</h2>
                    <hr className="category-line" />
                    <div id="tests" className="columns is-multiline">
                        {loading
                            ? Array.from({ length: 9 }).map((_, index) => (
                                <div className="column is-4 test" key={`skeleton-${index}`}>
                                    <Skeleton className="test-skeleton" height="280px" width="280px" />
                                </div>
                            ))
                            : tests.filter(test => test.category === 'recruitment').map(test => renderTest(test))}
                    </div>
                </div>

                <div className="category-section health">
                    <h2 className="category-title">Santé</h2>
                    <hr className="category-line" />
                    <div id="tests" className="columns is-multiline">
                        {loading
                            ? Array.from({ length: 9 }).map((_, index) => (
                                <div className="column is-4 test" key={`skeleton-${index}`}>
                                    <Skeleton className="test-skeleton" height="280px" width="280px" />
                                </div>
                            ))
                            : tests.filter(test => test.category === 'health').map(test => renderTest(test))}
                    </div>
                </div>

                {totalPages > 1 && (
                    <nav className="pagination is-centered is-primary" role="navigation" aria-label="pagination">
                        <ul className="pagination-list">
                            {Array.from({ length: totalPages }, (_, i) => (
                                <li key={i}>
                                    <a
                                        className={clsx('pagination-link', { 'is-current': i + 1 === currentPage })}
                                        onClick={() => handlePageClick(i + 1)}
                                    >
                                        {i + 1}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>
                )}
            </section>
        </>
    );

    const renderTest = (test) => {
        console.log('test', test);
        const isSelected = selectedTests.some(selectedTest => selectedTest.ref === test.ref);
        const isDisabled = selectedCategory && selectedCategory !== test.category;
        const testColor = test.test_color && test.test_color !== '#FFFFFF' ? test.test_color : '#4786C6';
        const imagePath = test.image_path || '/images/showcase/play/play-item-background-0.svg';
        const tagColor = test.tag_color || '';
        const tagName = test.tag_name || '';

        return (
            <div key={`test-${test.ref}`} className={clsx('column is-4 test', { 'disabled-test': isDisabled })}>
                <a
                    onClick={() => !isDisabled && handleTestClick(test)}
                    style={{
                        boxShadow: isSelected
                            ? `0 0 13px 0px ${testColor}`
                            : '0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02)',
                    }}
                >

                    <div className={clsx('tag-label', { 'is-invisible': !tagName })} style={{ backgroundColor: tagColor }}>{tagName}</div>

                    <img src={imagePath} className="background-img" />
                    <div className="tests_content">
                        <p className="title" style={{ color: testColor }}>{test.title}</p>
                        <p className="test_description pl-2 pr-2 is-hidden-mobile" style={{ color: testColor }}>
                            {test.sub_title}
                        </p>
                        <button
                            className={clsx('button is-info is-medium', {
                                'is-outlined is-light': !isSelected,
                                'disabled-btn': isDisabled,
                            })}
                        >
                            Selectionner
                        </button>
                    </div>
                </a>
            </div>
        );
    };

    const jobsRender = () => {
        const filteredJobsData = jobsData.filter(job => {
            const matchesCategory = selectedCategories.length === 0 || selectedCategories.includes(job.Catégorie);
            const matchesGlobalFilter = !globalFilter || Object.values(job).some(val => val && val.toString().toLowerCase().includes(globalFilter.toLowerCase()));
            return matchesCategory && matchesGlobalFilter;
        });

        const processedData = [];
        let lastCategory = null;
        filteredJobsData.forEach(job => {
            if (job.Catégorie !== lastCategory) {
                job.showCategory = true;
                lastCategory = job.Catégorie;
            } else {
                job.showCategory = false;
            }
            processedData.push(job);
        });

        const recommendationTemplate = (field) => (rowData) => {
            const value = rowData[field];
            return value ? <i className="pi pi-circle-fill" style={{ color: '#74C0FC' }}></i> : null;
        };

        const categoryBodyTemplate = (rowData) => {
            return rowData.showCategory ? (
                <span className='has-text-left'>{rowData.Catégorie}</span>
            ) : (
                <span className="has-text-left is-invisible">-</span>
            );
        };

        return (
            <div className="datatable-filter-demo">

                <div className="p-inputgroup mb-4">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-search"></i>
                    </span>
                    <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Rechercher des métiers..."
                    />
                    <MultiSelect
                        value={selectedCategories}
                        options={categories}
                        onChange={(e) => setSelectedCategories(e.value)}
                        placeholder="Sélectionner des catégories"
                        filter
                        filterPlaceholder="Rechercher une catégorie"
                        className="p-inputgroup-multiselect"
                        style={{ minWidth: '180px' }}
                    />
                </div>

                <div className="legend has-text-left my-4">
                    <span className='label'>Légende : </span>
                    <span className='mr-2'><i className="pi pi-circle-fill" style={{ color: '#74C0FC' }}></i> Recommandé</span>
                </div>

                <DataTable
                    className='has-text-left'
                    value={processedData}
                    paginator
                    rows={50}
                    rowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
                    emptyMessage="Aucun métier trouvé."
                    scrollable
                    scrollHeight="600px"
                >
                    <Column
                        field="Catégorie"
                        header="Catégorie"
                        body={categoryBodyTemplate}
                    />
                    <Column field="Métiers" header="Métiers" />
                    <Column field="Cyrious" header="Cyrious" body={recommendationTemplate('Cyrious')} />
                    <Column field="ExVert" header="ExVert" body={recommendationTemplate('ExVert')} />
                    <Column field="HopN" header="Hop-N" body={recommendationTemplate('HopN')} />
                    <Column field="Sympact" header="Sympact" body={recommendationTemplate('Sympact')} />
                    <Column field="Harmonia" header="Harmonia" body={recommendationTemplate('Harmonia')} />
                    <Column field="DTer" header="D-Ter" body={recommendationTemplate('DTer')} />
                </DataTable>
            </div>
        );
    };

    return (
        <section className="section has-text-centered pt-0 mt-0">
            <div className="tabs is-boxed is-centered mb-2 mt-0">
                <ul>
                    <li className={clsx({ 'is-active': activeTab === 'liana' })} onClick={() => setActiveTab('liana')}>
                        <a>
                            <span className="icon">
                                <i><img src="/images/dashboard/liana.svg" alt="liana sparkles" /></i>
                            </span>
                            <span>LiAna.</span>
                        </a>
                    </li>
                    <li className={clsx({ 'is-active': activeTab === 'tests' })} onClick={() => setActiveTab('tests')}>
                        <a>
                            <span className="icon is-small">
                                <i className="fa-solid fa-table-list" aria-hidden="true"></i>
                            </span>
                            <span>Liste des tests</span>
                        </a>
                    </li>
                    <li className={clsx({ 'is-active': activeTab === 'jobs' })} onClick={() => setActiveTab('jobs')}>
                        <a>
                            <span className="icon is-small">
                                <i className="pi pi-briefcase" aria-hidden="true"></i>
                            </span>
                            <span>Quel test choisir?</span>
                        </a>
                    </li>
                </ul>
            </div>
            {activeTab === 'liana' ? lianaRender() : activeTab === 'tests' ? testsRender() : jobsRender()}
        </section>
    );
};

export default StepThree;